import React, {useEffect} from 'react';
import {Box, IconButton, Stack, Typography} from '@mui/material';
import {useObservable} from '@ngneat/react-rxjs';
import {Outlet, useNavigate, useParams} from 'react-router-dom';

import {supplierDetailsQuery, supplierDetailsService} from '@store/suppliers/details';
import {suppliersUnitsService} from '@store/suppliers/units';
import {suppliersServicesService} from '@store/suppliers/services';

import {SupplierDetailsRoutes} from '@utils/routes.utils';

import {ArrowBack} from '@icons/index';

import RoutesTabsComponent from '@components/tabs/RoutesTabs.component';
import {documentsService} from '@store/documents';

const SupplierDetailsScreen = () => {
  const navigate = useNavigate();
  const {supplierId} = useParams();

  const [{headOffice}] = useObservable(supplierDetailsQuery.supplierDetails$);

  useEffect(() => {
    if (supplierId) {
      supplierDetailsService.getSupplierById(supplierId).subscribe();
    }

    return () => {
      supplierDetailsService.resetStore();
      suppliersUnitsService.resetStore();
      suppliersServicesService.resetStore();
      documentsService.resetStore();
    };
  }, [supplierId]);

  if (!headOffice.name) return null;

  const handleClose = () => {
    navigate('..', {replace: true});
  };

  return (
    <Stack flex={1} width="100%" pt="34px" px="24px" spacing={3} overflow="hidden">
      <Stack direction="row" alignItems="center" justifyContent="flex-start" spacing={1} ml="-9px">
        <IconButton onClick={handleClose}>
          <ArrowBack/>
        </IconButton>
        <Typography fontSize="30px" fontWeight="700">
          {headOffice?.name}
        </Typography>
      </Stack>
      <Stack flex={1} overflow="hidden">
        <Box>
          <RoutesTabsComponent routes={SupplierDetailsRoutes.routes()}/>
        </Box>
        <Outlet/>
      </Stack>
    </Stack>
  );
};

export default SupplierDetailsScreen;
